export class UpdateFindingExclusionRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "FindingObjectType",
            "format": ""
        },
        {
            "name": "detector",
            "baseName": "detector",
            "type": "FindingExclusionDetectorType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateFindingExclusionRequest.attributeTypeMap;
    }
    constructor() {
    }
}
